import React from "react";
import { Headline, Body, DoodleStar, DoodleHeart } from "../brand";
import Button from "../Button";
import WaveDivider from "../WaveDivider";
import { IconHeart, IconArrowRight, IconVerified } from "../brand/icons";

const practitionerAvatars = [
  { initials: "Dr", tone: "bg-cloud-mist text-spectrum-blue" },
  { initials: "OT", tone: "bg-spectrum-blue text-surface-white" },
  { initials: "SLP", tone: "bg-sunshine text-ink" },
];

const Becomeanally1 = () => {
  return (
    <div className="w-full flex flex-col items-stretch text-left">
      <section className="relative pt-12 pb-20 md:pt-14 md:pb-24 overflow-hidden bg-surface-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
          <div className="grid grid-cols-12 gap-x-0 gap-y-10 lg:gap-8 items-center">
            <div className="col-span-12 lg:col-span-6 flex flex-col items-start z-10">
              <div className="flex items-start gap-2 mb-4 max-w-[420px]">
                <IconHeart size={20} filled className="text-heart-teal shrink-0 mt-1" />
                <span className="font-accent-hand text-accent-hand text-heart-teal leading-snug">
                  Empower families with your lived &amp; professional expertise
                </span>
              </div>

              <Headline light="Join our" bold="village." as="h1" className="mb-6" />

              <Body className="w-full max-w-[520px] text-muted mb-8">
                Help build stronger support systems for families on the spectrum.
                Share your expertise with a community that needs your guidance.
              </Body>

              <div className="flex flex-wrap items-center gap-4">
                <Button to="/contactus" variant="primary" size="md">
                  Join Now
                  <IconArrowRight size={18} />
                </Button>
                <div className="flex items-center gap-2 px-3.5 py-2.5 rounded-brand bg-mist-chip border border-cloud-mist">
                  <span
                    className="w-2.5 h-2.5 rounded-full bg-sunshine inline-block"
                    aria-hidden="true"
                  />
                  <span className="text-label-sm font-semibold text-spectrum-blue">
                    NDIS &amp; Community Verified
                  </span>
                </div>
              </div>

              <div className="mt-10 pt-6 border-t border-cloud-mist flex items-center gap-4 w-full max-w-[520px]">
                <div className="flex -space-x-2 overflow-hidden shrink-0">
                  {practitionerAvatars.map((avatar) => (
                    <span
                      key={avatar.initials}
                      className={`inline-flex h-8 w-8 rounded-full ring-2 ring-surface-white items-center justify-center font-bold text-xs ${avatar.tone}`}
                    >
                      {avatar.initials}
                    </span>
                  ))}
                </div>
                <p className="text-label-sm font-semibold text-muted leading-normal">
                  Trusted by{" "}
                  <strong className="text-spectrum-blue">
                    1,200+ allied health practitioners
                  </strong>{" "}
                  and parent advocates.
                </p>
              </div>
            </div>

            <div className="col-span-12 lg:col-span-6 relative mt-12 lg:mt-0">
              <DoodleStar size={44} className="absolute -top-7 -left-4 z-20" />
              <DoodleHeart size={48} className="absolute -bottom-6 right-8 z-20" />

              <div className="relative rounded-2xl overflow-hidden border border-hairline shadow-comfort bg-surface-white p-2.5">
                <img
                  src="/images/photos/ally-community-gathering.webp"
                  alt="Diverse families and children gathering together at a sunny community event"
                  className="w-full h-[300px] sm:h-[400px] lg:h-[470px] object-cover object-center rounded-brand"
                  loading="lazy"
                />
                <div className="absolute bottom-6 left-6 bg-surface-white p-4 rounded-brand border border-hairline shadow-brand-lg max-w-[260px]">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue shrink-0">
                      <IconVerified size={22} />
                    </div>
                    <div>
                      <p className="text-label-md font-bold text-ink">
                        Safe &amp; Inclusive Network
                      </p>
                      <p className="text-label-sm font-semibold text-muted">
                        Caregivers matching daily
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WaveDivider
        fromClassName="bg-surface-white"
        waveClassName="text-mist-soft"
      />
    </div>
  );
};

export default Becomeanally1;
